export const enum CountryEnum {
    tr = "tr",
    usa = "usa",
    local = "local",
    world = "world"
}
